<template>
    <div class="apply-page-container">
        <!-- loading -->
        <div v-if="isLoading" class="loading-container">
            <DotFadeSpinner />
            <div class="loading-message">심사중입니다..</div>
        </div>

        <!-- results -->
        <div v-else class="apply-page">
            <!-- <div class="section-one">
                <div class="title-box">
                    <img class="icon" :src="require(`@/assets/images/icons/clap.svg`)" />
                    <div class="title">환영합니다</div>
                </div>
                <div class="sub-title">
                    <p>{{ me.name }}님은 가입 심사에</p>
                    <p>예비 <span class="highlight">'합격'</span> 하셨습니다.</p>
                </div>

                <div class="desc">
                    매칭률은
                    <span class="highlight-box" :class="`color-${resultNumber}`">
                        <img class="icon" :src="require(`@/assets/images/icons/hand.svg`)" />'{{
                            getWord(resultNumber)
                        }}' </span
                    >으로 예상됩니다.
                </div>
            </div>


            <div class="section-three">
                <div class="btn-desc">
                    <img class="icon" :src="require(`@/assets/images/icons/alarm-clock.svg`)" />
                    3분 소요
                </div>
                <div class="desc">
                    현재는 <span class="highlight">‘준회원'</span> 상태이며, 나머지 프로필을 완성하면<br />
                    최종 가입 심사 후 매니저를 배정해드려요
                </div>
            </div> -->

            <div class="section-four">
                <!-- 평가결과 -->
                <div class="apply-result-shorten">
                    <div class="title-box">
                        <div class="">
                            <i class="material-icons">check</i>
                        </div>
                        <div class="">심사 결과</div>
                    </div>
                    <div class="result-box">
                        <div class="sub-title">
                            <div class="first-line">{{ me.name }} 회원님은 가입 심사에</div>
                            <div class="second-line">
                                <div class="">예비</div>
                                <div class="highlight">
                                    <img
                                        class="icon"
                                        :src="require(`@/assets/images/icons/verify_check_green.svg`)"
                                    />합격
                                </div>
                                <div class="">하셨어요!</div>
                            </div>
                        </div>

                        <div class="desc">
                            매칭률은
                            <span class="highlight-box" :class="`color-${resultNumber}`">
                                <img class="icon" :src="require(`@/assets/images/icons/hand.svg`)" />'{{
                                    getWord(resultNumber)
                                }}' </span
                            >으로 예상됩니다.
                        </div>
                    </div>
                </div>

                <div v-if="gender === 0" class="images-container">
                    <!-- <img :src="require(`@/assets/images/onboard/evaluation/male_1.png`)" /> -->
                    <img :src="require(`@/assets/images/onboard/evaluation/male_2.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/male_3.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/male_4.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/male_6.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/male_5.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/male_7.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/male_8.png`)" />
                </div>
                <div v-if="gender === 1" class="images-container">
                    <!-- <img :src="require(`@/assets/images/onboard/evaluation/female_1.webp`)" /> -->
                    <img :src="require(`@/assets/images/onboard/evaluation/female_2.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/female_3.webp`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/female_4.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/female_5.webp`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/female_6.png`)" />
                    <img :src="require(`@/assets/images/onboard/evaluation/female_7.webp`)" />
                </div>
            </div>

            <div class="cta-contianer">
                <button class="btn" @click="goNextPage">
                    <!-- <p class="label f-regular">프로필 완성하기</p> -->
                    <p class="label f-regular">신규 특가로 가입하기</p>
                </button>
            </div>

            <!-- <div class="channel-talk-btn">
                <div class="channel-talk-inner">
                    <img :src="require(`@/assets/images/icons/channel-talk.png`)" alt="ChannelTalk Icon" />
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import userService from '@/services/user'
import { sendMetaTransition } from '@/services/meta-event'

export default {
    name: 'ApplyResultWithProductPage',
    components: {},
    data: () => ({
        version: 0,
        isLoading: true,
        isPassedTwoSeconds: false,
        resultNumber: null,
        _ran: false,
    }),
    computed: {
        me() {
            return this.$store.getters.me
        },
        profile() {
            return this.$store.getters.profile
        },
        products() {
            return this.$store.getters.products
        },
        gender() {
            return this.me.gender
        },
        targetProduct() {
            return this.products.unlimited.find(
                item =>
                    (this.me.gender === 0 && item.code === 'unlimited_male_new') ||
                    (this.me.gender === 1 && item.code === 'unlimited_female_new')
            )
        },
    },
    methods: {
        goNextPage() {
            // this.$router.push({ name: 'ChatsPage' })
            // this.$router.push({ name: 'SpecialOfferPage' })
            console.log(this.targetProduct)
            if (!this.targetProduct) {
                this.$toast.error('상품을 선택해주세요.')
                // 상품정보를 불러오지 못했을때, 홈으로 보내는게 낫지 않을까?
                this.$router.push({ name: 'ChatsPage' })
                return
            }

            this.$store.commit('setSelectedCoupon', null)
            this.$store.commit('setSelectedPoint', 0)
            this.$store.commit('setSelectedProduct', this.targetProduct)
            this.$store.commit('setSelectedPlan', this.targetProduct)
            this.$router.push({ name: 'PaymentMethodsPage', params: { categoryName: this.targetProduct } })
        },
        getWord(val) {
            if (val === 5) {
                return '매우 높음'
            } else if (val === 4) {
                return '높음'
            } else if (val === 3) {
                return '평균'
            } else {
                return '불합격'
            }
        },
        async handleAfterLoading() {
            // console.log('1.5초 후 실행될 이벤트 발생!')
            // 여기에 원하는 로직 추가

            const lookScoreSelf = this.profile.look_score_self
            const income = this.profile.income

            // 'very_high': 5, 'high': 4, 'avg': 3, 'failed': -1 이렇게 4개 값
            let result = -1

            if (this.me.gender === 0) {
                // 남자
                if (lookScoreSelf >= 80) {
                    result = 5
                } else if (lookScoreSelf >= 50) {
                    if (income >= 6000) {
                        result = 5
                    } else {
                        result = 4
                    }
                } else if (lookScoreSelf >= 30) {
                    if (income >= 6000) {
                        result = 3
                    } else {
                        result = -1
                    }
                } else {
                    if (income >= 6000) {
                        result = 3
                    } else {
                        result = -1
                    }
                }
            } else {
                // 여자
                if (lookScoreSelf >= 50) {
                    result = 5
                } else if (lookScoreSelf >= 30) {
                    result = 4
                } else {
                    result = -1
                }
            }
            this.resultNumber = result

            if (result >= 3) {
                // 합격 처리
                const payload = {
                    user_id: this.me.id,
                    status: 'success',
                }
                const res = await userService.profilePreJudgement(payload)
                if (res && res.res === 'success' && this.isPassedTwoSeconds) {
                    this.isLoading = false
                }
            } else if (result === -1) {
                // 불합격 처리
                const payload = {
                    user_id: this.me.id,
                    status: 'fail',
                }
                const res = await userService.profilePreJudgement(payload)
                if (res && res.res === 'success') {
                    const idx = this.$modal.basic({
                        title: '프로필 심사중',
                        body:
                            '심사 요청이 완료되었습니다. 심사 결과는 패스하신 경우에만 연락드리며, 패스하지 못한 경우 입력하신 모든 개인정보는 안전하게 파기되오니 안심하셔도 좋습니다.<br/>(패스하지 못한 경우 재신청이 가능합니다.)',
                        buttons: [
                            {
                                label: 'CANCEL',
                                class: 'btn-default',
                            },
                            {
                                label: 'CONFIRM',
                                class: 'btn-primary',
                            },
                        ],
                    })
                    if (idx) {
                        // 로그 아웃 후 홈으로
                        this.$store.dispatch('signOut')
                        this.$router.push({ name: 'HomePage' })
                    }
                }
            }
        },
        tryRunAfterLoading() {
            if (
                this.me &&
                this.profile &&
                this.me.gender !== undefined &&
                this.profile.look_score_self !== undefined &&
                !this._ran
            ) {
                this._ran = true
                this.handleAfterLoading()
                // setTimeout(() => {
                //     this.isLoading = false
                //     this.handleAfterLoading()
                // }, 1500)
            }
        },
    },
    mounted() {
        this.$ChannelBoot()

        this.$fbPixel.track('Schedule')
        sendMetaTransition('Schedule')

        setTimeout(() => {
            if (this.profile) {
                // this.handleAfterLoading()
                this.isPassedTwoSeconds = true
                if (this.resultNumber >= 3) {
                    this.isLoading = false
                }
            }
        }, 2000)

        // 심사 처리하기
    },
    beforeDestroy() {
        this.$ChannelShutdown()
    },
    watch: {
        me: {
            handler(newVal) {
                if (newVal && newVal.gender !== undefined) {
                    console.log('me 들어왔음:', newVal)
                    this.tryRunAfterLoading()
                }
            },
            immediate: true,
            deep: true,
        },
        profile: {
            handler(newVal) {
                if (newVal && newVal.look_score_self !== undefined) {
                    console.log('profile 들어왔음:', newVal)
                    this.tryRunAfterLoading()
                }
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>

<style lang="scss" scoped>
// .channel-talk-btn {
//   position: fixed;
//   bottom: 120px;
//   right: 18px;
//   z-index: 9999;
//   cursor: pointer;
// }

// .channel-talk-inner {
//   background: linear-gradient(rgb(246, 237, 219) 0%, rgb(246, 242, 219) 100%);
//   width: 44px;
//   height: 44px;
//   border-radius: 18px;
//   box-shadow: rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.1) 0px 4px 6px, rgba(0, 0, 0, 0.15) 0px 8px 30px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   transition: background-color 0.3s ease;
// }

// .channel-talk-inner img {
//   width: 38px;
//   height: 38px;
//   margin-top: 3px;
// }

.loading-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .loading-message {
        margin-top: 16px;
        color: black;
        font-size: 14px;
    }
}

.apply-page {
    // padding-left: 20px;
    // padding-right: 20px;
    padding-top: 0px !important;
    padding-bottom: 105px;
}
.section-one {
    margin: calc(150px - 56px) 0 70px 29px;
    text-align: left;

    .title-box {
        // margin-bottom: 35px;
        margin-bottom: 9px;

        .icon {
            margin-bottom: 12px;
            width: 30px;
            height: 30px;
            flex-shrink: 0;
            aspect-ratio: 1/1;
        }

        .title {
            // color: #070555;
            // // text-align: center;
            // font-feature-settings: 'liga' off, 'clig' off;
            // font-family: 'Gowun Dodum';
            // font-size: 28px;
            // font-style: normal;
            // font-weight: 400;
            // line-height: 150%; /* 42px */

            color: var(--Deep-Purple, #181f39);
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%; /* 20px */
        }
    }

    .sub-title {
        margin-bottom: 44px;

        // color: var(--Deep-Purple, #181f39);
        // font-feature-settings: 'liga' off, 'clig' off;
        // font-family: Pretendard;
        // font-size: 17px;
        // font-style: normal;
        // font-weight: 600;
        // line-height: 100%; /* 17px */

        color: var(--Deep-Purple, #181f39);
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 100%; /* 20px */

        > p:first-child {
            margin-bottom: 9px;
        }

        .highlight {
            color: #0a7;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%; /* 20px */

            // display: inline-block;
            // padding: 5px 8px;
            // justify-content: center;
            // align-items: center;
            // gap: 10px;

            // border-radius: 5px;
            // background: #0a7;

            // color: #fff;
            // font-feature-settings: 'liga' off, 'clig' off;
            // font-family: Pretendard;
            // font-size: 17px;
            // font-style: normal;
            // font-weight: 600;
            // line-height: 100%; /* 17px */
        }
    }

    .desc {
        display: flex;
        justify-content: start;
        align-items: center;
        gap: 3px;

        color: var(--Grey-787878, #787878);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 21px */

        .highlight-box {
            display: flex;
            padding: 3px 5px;
            justify-content: center;
            align-items: center;
            gap: 3px;

            border-radius: 5px;
            background: #f1f1f1;

            color: #3452d5;
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%; /* 21px */

            &.color-5 {
                color: #3452d5;
            }
            &.color-4 {
                color: #34bdd5;
            }
            &.color-3 {
                color: #4c4d51;
            }
            &.color--1 {
                color: #ff7d37;
            }
        }
    }
}

.section-two {
    background-color: lightgray;
    padding: 5px;
}

.section-three {
    button {
        height: 52px;
        width: 100%;
        font-size: 15px;
        background: $blue-primary;
        color: white;
        border-radius: 32px;
        border-width: 0;
        @include spoqa-f-medium;

        margin: 0 0 10px 0;

        p {
            color: #fdfcfa;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 17px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%;
        }
    }

    .btn-desc {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        margin-bottom: 18px;

        color: #3452d5;
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 16.5px */

        img {
            width: 15px;
            height: 15px;
            flex-shrink: 0;
            aspect-ratio: 1/1;
        }
    }

    .desc {
        color: var(--Grey-787878, #787878);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 11px;
        font-style: normal;
        font-weight: 300;
        line-height: 150%; /* 16.5px */

        .highlight {
            color: var(--Grey-787878, #787878);
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 11px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%;
        }
    }
}
.section-four {
    .apply-result-shorten {
        background-color: #212121;
        padding: 48px 24px;
        color: white;

        .title-box {
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 28px;
            font-style: normal;
            font-weight: 800;
            line-height: 100%; /* 20px */

            margin-bottom: 32px;

            i {
                color: white;
                font-size: 30px;
            }
        }

        .result-box {
            background-color: white;
            border-radius: 8px;
            padding: 20px 0;

            .sub-title {
                margin-bottom: 28px;

                font-feature-settings: 'liga' off, 'clig' off;
                font-family: Pretendard;
                font-size: 22px;
                font-style: normal;
                font-weight: 800;
                line-height: 100%; /* 20px */

                .first-line {
                    margin-bottom: 8px;
                    color: #7c7c7c;
                }
                .second-line {
                    margin-bottom: 0px;
                    color: #313131;

                    display: flex;
                    justify-content: center;
                    gap: 3px;
                }

                .highlight {
                    color: #0a7;

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: -1px;

                    img {
                        width: 24px;
                        height: 24px;
                    }
                }
            }

            .desc {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 3px;

                color: #a9a9a9;
                text-align: center;
                font-feature-settings: 'liga' off, 'clig' off;
                font-family: Pretendard;
                font-size: 15px;
                font-style: normal;
                font-weight: 700;
                line-height: 150%; /* 16.5px */

                .highlight-box {
                    display: flex;
                    padding: 3px 5px;
                    justify-content: center;
                    align-items: center;
                    gap: 3px;

                    border-radius: 5px;
                    background: #f1f1f1;

                    color: #3452d5;
                    text-align: center;
                    font-feature-settings: 'liga' off, 'clig' off;
                    font-family: Pretendard;
                    // font-size: 14px;
                    font-style: normal;
                    font-weight: 800;
                    line-height: 150%; /* 21px */

                    &.color-5 {
                        color: #3452d5;
                    }
                    &.color-4 {
                        color: #34bdd5;
                    }
                    &.color-3 {
                        color: #4c4d51;
                    }
                    &.color--1 {
                        color: #ff7d37;
                    }
                }
            }
        }
    }

    .image-container {
        display: flex;
        flex-wrap: wrap;
        gap: 0; /* 간격 제거 */
        line-height: 0; /* inline 요소 사이 간격 제거용 */
    }
    // .images-container > img {
    //     width: 100%;
    // }
    .images-container img {
        display: block; /* inline 요소 특성 제거 */
        // width: 100%; /* 원하는 이미지 크기로 지정 (예시) */
        // height: auto;  /* 세로 비율 유지 */
        vertical-align: top; /* 혹시모를 여백 제거 */

        width: auto;
        height: auto;
        max-width: 100%;
        image-rendering: crisp-edges;
    }
}

.cta-contianer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    background-color: transparent;

    // background-color: white;
    // border-top: 1px solid #e0e0e0;

    button {
        height: 52px;
        width: 100%;
        font-size: 15px;
        background: $blue-primary;
        color: white;
        border-radius: 32px;
        border-width: 0;
        @include spoqa-f-medium;

        margin: 0 0 10px 0;

        p {
            color: #fdfcfa;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 17px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%;
        }
    }
}
</style>
